import { type OperatorUserSession } from '@/features/auth/auth-model'
import { createContext, useContext } from 'react'

export type SessionContextValue = {
  session: OperatorUserSession
}

export const SessionContext = createContext<SessionContextValue | null>(null)

export function useSession(): SessionContextValue {
  const value = useContext(SessionContext)
  if (!value) {
    throw new Error('useSession must be used within SessionContext.Provider')
  }
  return value
}
